import ufcHero from '../../../media/papers/ufc/tom_aspinal.jpg';
import ufcPaper from '../../../media/papers/ufc/UFC_Fight_Prediction_Paper.pdf';

const ufcData = {
    name: "UFC Fight Prediction",
    category: "ML",
    tagline: "Predicting UFC Fight Outcomes Using Machine Learning",
    year: "2025",
    heroImage: ufcHero,

    description: "This study investigates two questions in UFC fight prediction: which pre-fight statistical factors best predict outcomes, and whether betting odds accurately reflect fight probabilities. Using 6,528 historical fights with 118 features, we trained and compared Logistic Regression and Random Forest models. Takedown differential and win streak differential were the strongest predictors. Given the multi-disciplinary nature of MMA and style-dependent matchups, interpretable feature ranking provides a practical basis for prediction modeling.",

    techStack: [
        "Python",
        "Scikit-learn",
        "Logistic Regression",
        "Random Forest",
        "Pandas",
        "NumPy"
    ],

    documents: [
        { type: 'pdf', src: ufcPaper, title: 'Read Research Paper' }
    ],
    documentTitle: "Paper"
};

export default ufcData;
